import TitleHeader from 'components/presenters/header/TitleHeader';
import React, { useEffect, useState } from 'react';
import { useCookies } from 'react-cookie';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

export default function CookieTest() {
  const userInfo = useSelector((state) => {
    return state.userInfo;
  });

  const [cookies, setCookies] = useCookies();
  const [visible, setVisible] = useState(false);

  const checkCookies = () => {
    const isVisible = cookies['is_visible'];
    if(isVisible)
    {
      return true;
    }
    return false;
  }

  const handleCookieSet = () => {
    if(!checkCookies())
    {
      setCookies('is_visible', 'true', {path: '/', maxAge: 60 * 60 * 24});
      setVisible(true);
    }
  }
   

  useEffect(() => {
    if(userInfo?.isLogin && checkCookies())
    {
      setVisible(true);
    }
  }, []);

  return (
    <>
      <HeaderBlock>
        <TitleHeader />
      </HeaderBlock>
      <BodyBlock>
        {visible ? (
          <div>
            쿠키 유지 중
          </div>
        ) : (~
          <div>
            <p>쿠키 없음</p>
            <Button onClick={handleCookieSet}>쿠키 생성</Button>
          </div>
        )}
        <Button onClick={() => window.location.reload()}>새로고침</Button>
      </BodyBlock>
    </>
  )
}

const Button = styled.button`
  background-color: #DBDBDB;
  padding: calc(100vw * (10 / 375)) 0;
  width: 100%;
`;

const HeaderBlock = styled.div`
  flex: 0 1 auto;
  min-height: calc(100vw * (50 / 375));
`;

const BodyBlock = styled.div`
  flex: 1 1 auto;
`;